/**
 * ServiceOrdersListPage - Página de Listagem de Ordens de Serviço.
 * RELEASE: 2026-10-18 v1.12.0 - Renderiza ServiceOrdersListView (corpo compartilhado com o modal
 *          de auditoria dos KPIs do Dashboard de O.S.). Comportamento inalterado.
 */
import { ServiceOrdersListView } from '@/components/service-orders/ServiceOrdersListView';

export default function ServiceOrdersListPage() {
  return <ServiceOrdersListView variant="page" />;
}
